/* eslint-disable no-alert */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { isPublicForm } from 'apps/web_forms/api/api';

import Arrow from 'apps/web_forms/assets/arrow.svg';
import { COLORS, LEAVE_WARNING_MSG } from 'apps/web_forms/utils/constants';

import ToggleButton from 'apps/web_forms/components/commons/ToggleButton';

const StyledHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  z-index: 4;

  a:hover {
    text-decoration: none;
  }

  .back-btn {
    background-color: transparent;
    border: none;
    height: 30px;
    width: 30px;
    margin-right: 0.5em;
    font-size: 18px;
  }
  .title-description-container {
    position: relative;
    z-index: 4;
    flex: 1;
    h1 {
      color: ${COLORS.titleGrey};
      font-weight: 500;
      font-size: 1.85em;
      margin: 0;
      line-height: 1;
    }
    h2 {
      font-weight: bold;
      font-size: 1.3em;
    }
    p {
      margin: 0;
      margin-top: 0.25em;
      color: ${COLORS.grey};
      font-size: 0.9em;
      line-height: 1;
    }
  }
`;
 
const StickyStyledHeader = styled(StyledHeader)`
  position: sticky;
  top: ${(props) => (props.notificationBarShowing ? '2.7em' : '0')};
  z-index: 4;
  display: ${(props) => (props.submitting ? 'none' : 'flex')};
  background-color: #ececec;
  .title-description-container {
    padding: ${(props) => (props.notificationBarShowing ? '0.5em 0' : '0')};
  }
`;

const isSubmission = window.location.href.includes('submission');

const FormPageHeader = ({
  small,
  title,
  description,
  draftDescription,
  goBackUrl,
  renderRightButton,
  renderSecondaryRightButton,
  renderToggleButton,
  sticky,
  isDraft,
  isSubmitting,
  notificationBarShowing,
  submissionId,
}) => {
  const history = useHistory();

  const onClickCloseForm = () => {
    if (isSubmission) {
      window.location.replace(goBackUrl);
    }
    if (!isPublicForm()) {
      history.push(goBackUrl);
    }
  };

  const Wrapper = sticky ? StickyStyledHeader : StyledHeader;

  const titleContent = !isDraft ? (
    title
  ) : (
    <>
      {`${title} - `}
      <span style={{ color: COLORS.red }}>draft</span>
    </>
  );

  return (
    <Wrapper notificationBarShowing={notificationBarShowing} submitting={isSubmitting}>
      {goBackUrl && !isPublicForm() && (
        <button
          className='back-btn'
          onClick={() => onClickCloseForm()}
          name='back'
          type='button'
          data-testid='form-back-button'
        >
          <Arrow />
        </button>
      )}

      <div className='title-description-container'>
        {small ? <h2>{titleContent}</h2> : <h1>{titleContent}</h1>}
        {description && <p>{description}</p>}
        {isDraft && draftDescription && (
          <p>{`Draft description: ${draftDescription}`}</p>
        )}
        {isSubmission && (
          <p>{`Submission ID: ${submissionId}`}</p>
        )}
      </div>
      {renderToggleButton && (<div className='right-button'><ToggleButton /></div>)}
      <div className='right-button'>{renderRightButton()}</div>
      {renderSecondaryRightButton &&
        typeof renderSecondaryRightButton === 'function' && (
          <div className='right-button'>{renderSecondaryRightButton()}</div>
        )}
    </Wrapper>
  );
};

FormPageHeader.propTypes = {
  small: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  draftDescription: PropTypes.string,
  goBackUrl: PropTypes.string,
  renderRightButton: PropTypes.elementType,
  renderSecondaryRightButton: PropTypes.elementType,
  renderToggleButton: PropTypes.bool,
  sticky: PropTypes.bool,
  isDraft: PropTypes.bool,
  notificationBarShowing: PropTypes.bool,
};

FormPageHeader.defaultProps = {
  small: false,
  title: 'You probably meant to include a title',
  description: '',
  draftDescription: undefined,
  goBackUrl: '',
  renderRightButton: () => {},
  renderSecondaryRightButton: () => {},
  sticky: false,
  isDraft: false,
  notificationBarShowing: false,
};

export default FormPageHeader;

